<template>
  <span>
    <dt-form-item v-if="periodOption.length > 1" :label="periodTypeLabel" inputType="select" v-model="periodType" :options="periodOption" />
    <dt-form-item
      :key="periodType"
      inputType="date-picker"
      v-model="value_"
      :label="periodLabel"
      @change="updateValue"
      :componentAttr="{
        type: periodType,
        format: pickerProps[periodType].format,
        pickerOptions: { firstDayOfWeek: 1, disabledDate, onPick: (newTempValue) => Object.assign(tempValue, newTempValue) },
        placeholder: pickerProps[periodType].placeholder,
        startPlaceholder: '开始日期',
        endPlaceholder: '结束日期',
        unlinkPanels: true,
        clearable,
      }"
    />
  </span>
</template>

<script>
import { formatDate } from "@/utils/format-time";
export default {
  name: "DtDateRange",
  components: { DtFormItem: () => import("../../index.vue") },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    // 起始值绑定(sync)
    startValue: { default: null },
    // 结束值绑定(sync)
    endValue: { default: null },
    // 可清除日期
    clearable: { type: Boolean, default: false },
    // 日期限制,（字符串）函数
    dateLimit: { type: [Function, String], default: () => false },
    // 周期类型可选值
    availablePeriod: {
      type: [Array, String],
      validator(val) {
        const type = typeof val,
          validator = (types) => types.every((E) => ["daterange", "week", "month"].includes(E));
        if (type === "string") return validator(val.split(","));
        if (Array.isArray(val)) return validator(val);
        return false;
      },
      default: () => ["daterange", "week", "month"],
    },
    // 空值的替代值
    emptyValue: { default: null },
    // 标签
    periodTypeLabel: { type: String, default: "" },
    periodLabel: { type: String, default: null },
  },
  data() {
    return {
      // element周选择存储第二列的值，奇葩😓
      value_: "",
      tempValue: { maxDate: null, minDate: null }, // 临时的选择（范围选中其中一个）
      periodType: (Array.isArray(this.availablePeriod) ? this.availablePeriod : this.availablePeriod.split(","))[0],
      pickerProps: {
        daterange: {
          placeholder: "任意日期",
          format: "yyyy-MM-dd",
        },
        week: {
          placeholder: "按周选择",
          format: "yyyy 年 第 WW 周",
        },
        month: {
          placeholder: "按月选择",
          format: "yyyy 年 MM 月",
        },
      },
    };
  },
  computed: {
    periodOption() {
      const option = [
          { label: "任意日期", value: "daterange" },
          { label: "按周选择", value: "week" },
          { label: "按月选择", value: "month" },
        ],
        availablePeriod = Array.isArray(this.availablePeriod) ? this.availablePeriod : this.availablePeriod.split(",");
      return option.filter(({ value }) => availablePeriod.includes(value));
    },
    disabledDate() {
      const type = typeof this.dateLimit;
      let disabledFn;
      if (type === "function") disabledFn = this.dateLimit;
      else if (type === "string") disabledFn = new Function(`return ${this.dateLimit}`)();
      else return undefined;

      return disabledFn.bind(null, { tempValue: this.tempValue });
    },
  },
  watch: {
    value(val) {
      this.syncValue(val);
    },
    startValue(val) {
      this.syncValue([val, this.endValue]);
    },
    endValue(val) {
      this.syncValue([this.startValue, val]);
    },
    periodType() {
      if (!this.value_ || (Array.isArray(this.value_) && !this.value_[0])) return;
      this.syncValue(this.value);
      this.updateValue();
    },
  },
  methods: {
    syncValue(valueArr) {
      let value = null;
      if (this.periodType === "daterange") value = valueArr.map((E) => (E ? new Date(E) : ""));
      else value = valueArr[0] ? new Date(valueArr[0]) : "";
      this.value_ = value;
    },
    updateValue() {
      let start, end;
      if (!this.value_ || (Array.isArray(this.value_) && !this.value_[0])) start = end = this.emptyValue;
      else {
        if (this.periodType === "daterange") [start, end] = this.value_;
        else if (this.periodType === "week") {
          const value = new Date(this.value_),
            day = value.getDay();
          start = new Date(value * 1 - 864e5 * (day - 1));
          end = new Date(value * 1 + 864e5 * (7 - day));
        } else if (this.periodType === "month") {
          const value = new Date(this.value_),
            month = value.getMonth();
          start = new Date(value.setDate(1));
          end = new Date(value.setMonth(month + 1, 0));
        }
        start = formatDate(start);
        end = formatDate(end);
      }
      this.$emit("input", [start, end]);
      this.$emit("change", [start, end]);
      this.$emit("update:startValue", start);
      this.$emit("update:endValue", end);
    },
  },
};
</script>
